import { render, staticRenderFns } from "./FilterSelected.vue?vue&type=template&id=423d6d52&"
import script from "./FilterSelected.vue?vue&type=script&lang=js&"
export * from "./FilterSelected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports